import api from '@/api';

/**
 * Fetches a scoped subset of customers by uid, optionally projecting to a
 * subset of fields. This replaces the whole-directory `fetchCustomers` Vuex
 * action + `getCustomer` getter for views (eg. Packing) that only need a
 * handful of fields for the customers referenced by the current orders.
 *
 * Not a Vuex store — components hold the returned map in their own reactive
 * `data` so Vue tracks it. Keep this class thin: fetch + dedup + shape.
 */
export default class CustomerLookup {
  /**
   * @param {string[]|null} fields top-level customer fields to request, or null for the full object
   */
  constructor(fields = null) {
    this.fields = fields;
  }

  /**
   * @param {string[]} uids customer uids (deduped internally; empties dropped)
   * @returns {Promise<Object>} map of uid -> customer
   */
  async load(uids) {
    const unique = [...new Set(uids)].filter(Boolean);
    if (unique.length === 0) {
      return {};
    }
    const {data} = await api.post('v2/customers', {uids: unique, fields: this.fields});
    return Object.fromEntries(data.map(c => [c.uid, c]));
  }
}
